import { Pipe, PipeTransform } from '@angular/core';

export type PaymentStatus =
  'new'
  | 'completed'
  | 'failed'
  | 'cancelled'
  | 'pending'
  | 'expired'
  | 'processing'
  | 'no-info'
  | string;

@Pipe({
  name: 'paymentStatus',
  standalone: true
})
export class PaymentStatusPipe implements PipeTransform {

  transform(value?: PaymentStatus): string {
    switch (true) {
      case value === 'new': {
        return 'Nowa';
      }
      case value === 'completed': {
        return 'Twoja płatność została zrealizowana.';
      }
      case value === 'failed': {
        return 'Niestety Twoja płatność nie została zrealizowana.';
      }
      case value === 'cancelled': {
        return 'Twoja płatność została anulowana.';
      }
      case value === 'pending': {
        return 'Twoja płatność jest w trakcie przetwarzania.';
      }
      case value === 'expired': {
        return 'Wygasł czas na potwierdzenie Twojej płatności.';
      }
      case value === 'processing': {
        return 'Oczekiwanie na potwierdzenie Twojej płatności.';
      }
      case value === 'no-info': {
        return 'Brak informacji o statusie Twojej płatności.';
      }
      default:
        return value || '';
    }
  }

}
